import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js"
import SimpleMaskMoney from "simple-mask-money"

// Tipos predefinidos de máscara
const PRESETS = {
  ciclo:         { blocks: [2, 4], delimiter: "/", numericOnly: true },
  mes_ano:       { blocks: [2, 4], delimiter: "/", numericOnly: true },
  cpf:           { blocks: [11], numericOnly: true },
  cpf_formatted: { blocks: [3, 3, 3, 2], delimiters: [".", ".", "-"], numericOnly: true },
  cnpj:          { blocks: [2, 3, 3, 4, 2], delimiters: [".", ".", "/", "-"], numericOnly: true },
  rg:            { blocks: [10], numericOnly: true },
  cep:           { blocks: [5, 3], delimiter: "-", numericOnly: true },
  phone:         { blocks: [0, 2, 9], delimiters: ["(", ") "], numericOnly: true },
  cpf_cnpj:     { blocks: [14], numericOnly: true },
  hora:         { blocks: [2, 2], delimiter: ":", numericOnly: true },
  date:         { date: true, datePattern: ["d", "m", "Y"], delimiter: "/" }
}

const MONEY_OPTIONS = {
  allowNegative: false,
  negativeSignAfter: false,
  prefix: "",
  fixed: true,
  fractionDigits: 2,
  decimalSeparator: ",",
  thousandsSeparator: ".",
  cursor: "end"
}

export default class extends Controller {
  static values = { type: String }

  connect() {
    if (this.typeValue === "money") {
      const wasEmpty = !this.element.value.trim()
      SimpleMaskMoney.setMask(this.element, MONEY_OPTIONS)
      if (wasEmpty) this.element.value = ""
    } else {
      const options = PRESETS[this.typeValue]
      if (options) {
        this.cleave = new Cleave(this.element, options)
      }
    }
  }

  disconnect() {
    if (this.typeValue === "money") {
      SimpleMaskMoney.removeMask(this.element)
    } else {
      this.cleave?.destroy()
    }
  }
}
